// 单文件引入方式

import SortableInputs from './ZuiSortableInputs.vue'

export default {
  install(Vue) {
    Vue.component('ZuiSortableInputs', SortableInputs)
  }
}

export { SortableInputs }
